import { useSurfaceChat } from '../../surface-chat/useSurfaceChat';
import { useL2CChatStore } from '../stores/useL2CChatStore';

/** Where the monitor's thread id has always been kept — so old chats carry on. */
const L2C_CHAT_THREAD_KEY = 'klaris_l2c_chat_thread_id';

/** The chat docked beside the Lead-to-Cash monitor: the same docked chat the boards use. */
export function useLeadToCashChat(
  getSurfaceContext: () => Record<string, unknown> | null,
  enabled: boolean,
) {
  return useSurfaceChat({
    useStore: useL2CChatStore,
    threadKey: 'lead-to-cash',
    storageKey: L2C_CHAT_THREAD_KEY,
    getSurfaceContext,
    enabled,
  });
}
